import { cn } from "@/core/helpers/cn";

type Props = {
  percent: number;
  size?: "sm" | "md" | "lg" | "xl" | number; // Можно передать либо размер из пресета, либо конкретное число (в px)
  className?: string;
};

export default function InventoryCoolDown({ percent, size = "md", className }: Props) {
  // Определяем размеры в зависимости от пропса
  const sizeClasses = {
    sm: "w-12 text-lg",
    md: "w-16 text-xl",
    lg: "w-20 text-2xl",
    xl: "w-24 text-3xl",
  };

  const sizeStyle =
    typeof size === "number"
      ? { width: `${size}px`, height: `${size}px`, fontSize: `${size * 0.375}px` }
      : undefined;

  return (
    <div
      className={cn(
        "relative aspect-square rounded-full bg-canvas text-white flex items-center justify-center font-bold",
        typeof size === "string" ? sizeClasses[size] : "",
        className,
      )}
      style={
        {
          "--progress": `${percent}%`,
          ...(sizeStyle || {}),
        } as React.CSSProperties
      }
    >
      <div className="absolute inset-[calc(11%)] rounded-full bg-gradient-accent opacity-10 hidden dark:block" />

      <div className="absolute inset-[calc(11%)] rounded-full bg-gradient-accent opacity-40 [mask-image:radial-gradient(circle_at_center,transparent,transparent_60%,black_60%,black_90%)]" />

      <div className="absolute inset-[calc(5.5%)] rounded-full [mask-image:conic-gradient(black,black_var(--progress),transparent_var(--progress))]">
        <div className="absolute inset-0 rounded-full bg-gradient-accent [mask-image:radial-gradient(circle_at_center,transparent,transparent_50%,black_50%,black_64%,transparent_64%)]" />
      </div>

      <div className="relative z-10 leading-[0.75]">{percent}</div>
    </div>
  );
}
